export default {"src":"/_next/static/media/default-collection-image.aee3878e.svg","height":81,"width":77,"blurWidth":0,"blurHeight":0};